import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import { ChevronRight } from "lucide-react";

const ease = [0.22, 1, 0.36, 1];

export const PageHero = ({ eyebrow, title, sub, crumb, image }) => (
  <section className="pt-28 sm:pt-32" data-testid="page-hero">
    <div className="container-x">
      <div className="relative overflow-hidden rounded-[2rem] bg-navy px-6 py-14 sm:rounded-[2.5rem] sm:px-12 sm:py-20">
        {image && (
          <div className="absolute inset-0">
            <img src={image} alt="" className="h-full w-full object-cover opacity-25" />
            <div className="absolute inset-0 bg-gradient-to-r from-navy via-navy/85 to-navy/40" />
          </div>
        )}
        <div className="pointer-events-none absolute -right-20 -top-20 h-72 w-72 rounded-full bg-gold/20 blur-[110px]" />

        <div className="relative max-w-3xl">
          <motion.div
            initial={{ opacity: 0, y: 12 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, ease }}
            className="flex items-center gap-1.5 text-xs font-medium text-white/50"
          >
            <Link to="/" className="hover:text-gold-300">Home</Link>
            <ChevronRight size={13} />
            <span className="text-gold-300">{crumb || eyebrow}</span>
          </motion.div>

          <motion.span
            initial={{ opacity: 0, y: 14 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, ease, delay: 0.05 }}
            className="mt-6 inline-flex items-center gap-2 rounded-full bg-white/8 px-4 py-1.5 text-xs font-medium uppercase tracking-[0.16em] text-gold-300"
          >
            {eyebrow}
          </motion.span>

          <motion.h1
            initial={{ opacity: 0, y: 22 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, ease, delay: 0.12 }}
            className="mt-5 font-display text-4xl font-semibold leading-[1.02] tracking-tight text-white sm:text-6xl"
          >
            {title}
          </motion.h1>

          {sub && (
            <motion.p
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.8, ease, delay: 0.2 }}
              className="mt-5 max-w-xl text-base leading-relaxed text-white/70 sm:text-lg"
            >
              {sub}
            </motion.p>
          )}
        </div>
      </div>
    </div>
  </section>
);
